// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__3xLKx","icon":"style_icon__1LhF4","title":"style_title__1wBUt"};